export default function(data) {
  var self = this;
  self.$loaderHolder = $('body');
  self.location = ko.observable('');
  self.firstLoad = ko.observable(true);
  self.partialFiles = ko.observableArray();
  self.showSidebar = ko.observable(false);
  self.topNavTitle = ko.observable('Disciplina');
  self.topNavSubtitle = ko.observable('Corruptissima re publica plurimae leges');
  self.topNavDescription = ko.observable('Tellus phasellus aenean augue at..');

  self.bindData = function(data) {
    self.partialFiles(data);
  };

  self.initUI = function() {
    self.initScrollEvents();
    if (self.firstLoad() && _.isEmpty(window.location.hash)) {
      self.showSidebar(true);
      self.location = ko.observable('');
      self.firstLoad(false);
    } else if (self.firstLoad()) {
      self.showSidebar(false);
      var $el = $(window.location.hash);
      $el.click();
      self.firstLoad(false);
    }
    Kadenze.UIUtil.hideLoadingIndicator(self.$loaderHolder);
  };

  self.initScrollEvents = function() {
    $(document).on('scroll', function() {
      if ($(document).scrollTop() > 100) {
        $('.style-guide__header').addClass('shrink');
      } else {
        $('.style-guide__header').removeClass('shrink');
      }
    });
  };

  self.updateLocation = function(path, id) {
    self.location(path);
    self.getContent();
    window.location.hash = '#' + id;
  };

  self.updateTopNavText = function() {
    // jump to top of page and show section
    $('html,body').scrollTop(0);

    var $section = $('.style-guide__content');
    self.topNavTitle($('.style-guide__section_title', $section).text());
    self.topNavSubtitle($('.style-guide__section_subtitle', $section).text());
    self.topNavDescription($('.style-guide__section_description', $section).text());

    // adjust page content padding to header height
    setTimeout(function() {
      var headerH = $('.js-sgHeader').outerHeight() + 48;
      $('.js-sgContent').attr('style', 'padding-top: ' + headerH + 'px');
    }, 50);
  };

  self.toggleSidebar = function() {
    if (self.showSidebar()) {
      self.showSidebar(false);
    } else {
      self.showSidebar(true);
    }
  };

  self.initializeModules = function(container, amd) {
    //TODO: This is the same code used in kadenze-glue. Need to modularize this into a reusable lib and clean it up.
    var $container = container ? $(container) : $('body');
    var moduleSelector = amd ? '[data-module-amd]' : '[data-module]';
    var moduleEles = $(moduleSelector, $container);
    var poppingState = $.pjax.popping;
    _.each(moduleEles, function (_ele, _idx) {
      var names = $(_ele).data(amd ? 'module-amd' : 'module').split(',');
      for (var i = 0; i < names.length; i++) {
        var attemptModuleInit = function (i) {
          if (typeof names[i] == 'undefined')
            return;

          var name = names[i].trim();
          var module = window['Kadenze'];
          var tokens = name.split('.');
          if (name === '')
            return;

          while (tokens.length > 0) {
            var token = tokens.shift();
            if (typeof module[token] === 'undefined') {
              console.warn('Module ' + name + ' not found');
              if (amd)
                setTimeout(attemptModuleInit.bind(this, i), 100);
              return;
            } else {
              module = module[token];
            }
          }
          if (module && module !== undefined) {
            if ($.pjax && poppingState && module.prepUI) {
              module.prepUI.apply();
            }

            if (module.init) {
              console.log('Initializing Module: ' + name);
              module.init.apply(null, [_ele]);
            } else {
              console.warn('Module ' + name + ' specified, but no initialization function present');
            }
          } else if (name !== '') {
            console.warn('Module ' + name + ' specified, but no corresponding module found');
          }
        };
        if (amd) {
          setTimeout(attemptModuleInit.bind(this, i), 100);
        } else {
          attemptModuleInit(i);
        }
      }
    });
  };

  self.getContent = function() {
    Kadenze.UIUtil.showLoadingIndicator(self.$loaderHolder);
    var file = { file: self.location() };
    var url = Kadenze.Routes.style_guide_render_partial_path(file);

    var request = new Kadenze.AjaxRequest({
      url: url,
      dataType: 'html',
      type: 'GET'
    });

    request.done(function(data) {
      Kadenze.UIUtil.hideLoadingIndicator(self.$loaderHolder);
      // Looks like we need to use jQuery as opposed to a ko html
      // binding since the latter doesn't run script tags automatically
      $('.style-guide__content').html(data);
      self.initializeModules($('.style-guide__content'), true);
      self.updateTopNavText();
    });

    request.fail(function(data) {
      console.log(data);
      Kadenze.UIUtil.hideLoadingIndicator(self.$loaderHolder);
    });
  };

  self.collapseItems = function(data, event) {
    if (!_.isUndefined(event)) {
      $(event.target).next().find('li').collapse('toggle');
    }
  };

  self.showSidebar.subscribeChanged(function(value) {
    if (value) {
      $('.style-guide').addClass('menu-is-open');
    } else {
      $('.style-guide').removeClass('menu-is-open');
    }
  });

  const __construct = (function(that) {
    console.log('constructor called for Kadenze.StyleGuide');
    Kadenze.UIUtil.showLoadingIndicator(that.$loaderHolder, null, 'fixed');
    that.bindData(data);
  })(this);
}

